// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"92d7cf88","875":"b37fad64","889":"684ed760"}[chunkId] + ".chunk.js";
};